import { FormControl, FormHelperText, TextField } from '@mui/material';

interface TxtCategoriaOuvidoriaProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  helperText?: string;
  required?: boolean;
  name?: string;
  disabled?: boolean;
}

export const TxtCategoriaOuvidoria = ({ value, onChange, helperText, required = false, name = 'categoria', disabled = false }: TxtCategoriaOuvidoriaProps) => {
  return (
    <FormControl fullWidth size="small">
      <TextField select required={required} size="small" name={name} value={value} onChange={onChange} SelectProps={{ native: true }} disabled={disabled}>
        <option value="">Selecione a Categoria</option>
        <option value="ATIVIDADES-EXERCIDAS">Atividades exercidas</option>
        <option value="DENUNCIA">Denúncia</option>
        <option value="ELOGIO">Elogio</option>
        <option value="RECLAMACAO">Reclamação</option>
        <option value="SOLICITACAO">Solicitação</option>
        <option value="SUGESTAO">Sugestão</option>
        <option value="UTILIZACAO-RECURSOS-PUBLICOS">Utilização de recursos públicos</option>
      </TextField>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
